var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{staticClass:"p-0"},[_c(_vm.Parameter.Type + 'Modal',{tag:"component",attrs:{"Parameter":_vm.Parameter,"Variant":_vm.Variant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }